import { ServerError } from '@/api/config.ts';

class ServerErrorService {
  private error: ServerError | null = null;
  private errorToast: ServerError | null = null;
  private listeners: ((
    errorToast: ServerError | null,
    error: ServerError | null
  ) => void)[] = [];
  private timer: NodeJS.Timeout | null = null;

  private notifyListeners() {
    this.listeners.forEach((listener) => {
      listener(this.errorToast, this.error);
    });
  }

  private startToastTimer(timeout: number) {
    if (this.timer) {
      clearTimeout(this.timer);
    }

    this.timer = setTimeout(() => {
      this.clearErrorToast();
    }, timeout);
  }

  subscribe(
    callback: (
      errorToast: ServerError | null,
      error: ServerError | null
    ) => void
  ) {
    this.listeners.push(callback);

    callback(this.errorToast, this.error);

    return () => {
      this.listeners = this.listeners.filter(
        (listener) => listener !== callback
      );
    };
  }

  setError(error: ServerError | null, timeout: number = 10000) {
    this.error = error;
    this.errorToast = error;
    this.notifyListeners();

    if (error) {
      this.startToastTimer(timeout);
    }
  }

  clearError() {
    this.error = null;
    this.clearErrorToast();
  }

  clearErrorToast() {
    this.errorToast = null;
    this.notifyListeners();
  }

  getError(): ServerError | null {
    return this.error;
  }

  getErrorCode(): number | null {
    if (this.error?.status) {
      return this.error.status;
    }

    return null;
  }
}

export const serverErrorService = new ServerErrorService();
